import type { ConfigurationFacet, Facet } from '../types'

import { transformFacetsValues } from './transformFacetsValues'

/**
 * Builds UI-ready filter facets by combining configuration, current state, and Algolia data.
 *
 * For each configured facet:
 * - If the facet has selected values (is filtered), preserves those values
 * - Otherwise, generates fresh values from Algolia facet counts
 *
 * @param facets - Current facet state with user selections
 * @param defaultFacets - Static facet configuration from PLP config
 * @param algoliaFacets - Raw Algolia facet counts grouped by facet name
 * @returns Array of facets ready for UI rendering
 */
export function buildUiFilters(
  facets: Facet[],
  defaultFacets: ConfigurationFacet[],
  algoliaFacets?: Record<string, Record<string, number>>,
): Facet[] {
  return defaultFacets.map((defaultFacet) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const facet = facets.find((facet) => facet.name === defaultFacet.name)
    const isFilteredFacet = facet && facet.values && facet.values.length > 0

    const baseFacet = {
      title: defaultFacet.title,
      name: defaultFacet.name,
      type: defaultFacet.type,
    }

    if (isFilteredFacet) {
      return {
        ...baseFacet,
        values: facet.values || [],
      }
    }

    return {
      ...baseFacet,
      values: transformFacetsValues(
        algoliaFacets?.[defaultFacet.name],
        defaultFacet.isSortedByBusiness,
      ),
    }
  })
}
